import { render } from "./ButtonCheckBox.vue?vue&type=template&id=72765dec"
import script from "./ButtonCheckBox.vue?vue&type=script&lang=js"
export * from "./ButtonCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/input/ButtonCheckBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72765dec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72765dec', __exports__)) {
    console.log('reload')
    api.reload('72765dec', __exports__)
  }
  
  module.hot.accept("./ButtonCheckBox.vue?vue&type=template&id=72765dec", () => {
    console.log('re-render')
    api.rerender('72765dec', render)
  })

}


export default __exports__